module.exports = __webpack_public_path__ + "img/footer_text.4d59b2cb.png";